import React, { useEffect, useState } from 'react';
import { useMatchesMinimized } from '../../hooks/matches';
import MatchRow from './MatchRow';
import MatchRowRound from './MatchRowRound';
import {
  getMatchesPrefixedByRound,
  getMatchesPrefixedByWeek,
} from '../../utils/matches';
import MatchRowWeek from './MatchRowWeek';

function MatchesList(props) {
  const { orderBy, season, team, round } = props;
  const [matches, setMatches] = useState(null);
  const [data, loading, error] = useMatchesMinimized(season);

  useEffect(() => {
    if (data && data.length > 0) {
      const filteredData =
        team !== 'all'
          ? data.filter(
              (item) =>
                item.homeTeamAbbrv === team || item.visitingTeamAbbrv === team
            )
          : data;

      const filteredData2 =
        round !== 'all'
          ? filteredData.filter((item) => Number(item.round) === Number(round))
          : filteredData;

      const orderedData =
        orderBy === 'round'
          ? getMatchesPrefixedByRound(filteredData2)
          : getMatchesPrefixedByWeek(filteredData2);
      setMatches(orderedData);
    }
  }, [data, orderBy, setMatches, season, team, round]);

  if (loading) return <p className="text-center p-4">Loading...</p>;

  return matches?.map((item) => {
    if (item?.isHeader) {
      if (item.type === 'round') {
        return <MatchRowRound item={item} />;
      }

      if (item.type === 'week') {
        return <MatchRowWeek item={item} />;
      }
    }
    return <MatchRow item={item} />;
  });
}

export default MatchesList;
